import 'pure-css-loader/dist/css-loader.css';
import { safeRemoveChild } from './helpers';

export interface Overlay {
    show: () => void;
    hide: () => void;
}

export function createOverlay(targetElement: HTMLElement): Overlay {
    const loader = document.createElement('div');

    const show = () => {
        loader.style.width = '100%';
        loader.style.height = '100%';
        loader.style.backgroundColor = 'black';
        loader.style.opacity = '0.8';
        loader.style.position = 'absolute';
        loader.style.zIndex = '9999';
        loader.classList.add('loader-bouncing');
        targetElement.prepend(loader);
    };

    const hide = () => {
        safeRemoveChild(targetElement, loader);
    };

    return { show, hide };
}
